import { browserSupportsWebAuthn } from '@simplewebauthn/browser'
import { useMemo } from 'react'

export const useIsPasskeySupported = () => {
	const isAvailable = useMemo(() => browserSupportsWebAuthn(), [])

	return isAvailable
}
